import React from "react";
import { Dialog, Card, Pane, Strong, Text, Button, Link, TickCircleIcon, BanCircleIcon, WarningSignIcon } from "evergreen-ui";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import MarkNoSHow from "./markNoShow";
import EnableReschedule from "./enableReschedule";
import { getCookie, getCurrency, getFormattedTime } from "../util";

const UnavailabilityDialog = (props) => {
  const {
    isShown,
    showDialog,
    date,
    slotUnavailabilityData,
    showConfirmationDialog,
    cancelBooking,
    showEditAmountDialog,
    sendBookingPaymentLink,
    showGetInTouchDialog,
    getSlotLockedStatus,
    onNoShow,
    enableReschedule,
  } = props;
  const activityType = localStorage.getItem("activityType") || "0";

  return (
    <Dialog
      isShown={isShown}
      title={"Slot Details"}
      onCloseComplete={() => showDialog(false)}
      hasFooter={false}
    >
      {slotUnavailabilityData ? (
        slotUnavailabilityData.data &&
        slotUnavailabilityData.data.map((slot, index) => {
          if (slot.status === "Booked") {
            const paid = slot["gross"] - slot["paymentPending"];
            return (
              <Card
                key={index}
                padding={15}
                marginTop={10}
                marginBottom={10}
                border={"default"}
                display={"flex"}
                justifyContent={"space-between"}
                flexDirection={"column"}
              >
                <Pane
                  display={"flex"}
                  flexDirection={"row"}
                  flexBasis={"100%"}
                  justifyContent={"flex-start"}
                  marginTop={10}
                  marginBottom={10}
                >
                  <Strong marginRight={10} marginTop={2}>{` ${slot["bookingId"]}`}</Strong>
                  {/* {slot['isPlayoBooking'] && (
                    <img src='https://playo-website.gumlet.net/logo/Playo_green_512.png?auto=compress&h=23&w=23' />
                  )} */}
                </Pane>

                <Pane
                  display={"flex"}
                  flexDirection={"row"}
                  flexBasis={"100%"}
                  justifyContent={"space-between"}
                  marginTop={10}
                  marginBottom={10}
                >
                  <Text>{slot["activityName"]}</Text>
                  <Text>
                    {slot["courtName"]}

                    {parseInt(activityType) === 1 && `   |  ${slot.slotCount}  Slot(s)`}
                  </Text>
                </Pane>
                <Pane
                  display={"flex"}
                  flexDirection={"row"}
                  flexBasis={"100%"}
                  justifyContent={"space-between"}
                  marginBottom={10}
                >
                  <Text>{date}</Text>
                  <Text>
                    {`${getFormattedTime(slot["startTime"])} - ${getFormattedTime(
                      slot["endTime"]
                    )}`}
                  </Text>
                </Pane>
                <Pane
                  display={"flex"}
                  flexDirection={"row"}
                  flexBasis={"100%"}
                  justifyContent={"space-between"}
                  marginBottom={20}
                >
                  <Text>{slot["customerName"]}</Text>
                  {getCookie("countryCode") === "+91" && slot["isPlayoBooking"] ? (
                    <Link
                      onClick={() =>
                        showGetInTouchDialog(true, {
                          bookingId: slot["bookingId"],
                          slot: slot["startTime"],
                        })
                      }
                    >
                      {slot["customerMobile"]}
                    </Link>
                  ) : (
                    <Strong
                      is='a'
                      href={`tel:${slot["customerMobile"]}`}
                      className={"no-underline"}
                    >
                      {slot["customerMobile"]}
                    </Strong>
                  )}
                </Pane>
                <Pane
                  display={"flex"}
                  flexDirection={"row"}
                  flexBasis={"100%"}
                  justifyContent={"space-between"}
                  marginBottom={20}
                  alignItems={"center"}
                >
                  <Pane
                    display={"flex"}
                    flexDirection={"column"}
                    justifyContent={"space-between"}
                    alignItems={"flex-start"}
                  >
                    <Pane
                      hight={32}
                      display={"flex"}
                      flexDirection={"row"}
                      justifyContent={"space-evenly"}
                      alignItems={"center"}
                    >
                      {paid === slot["gross"] ? (
                        <TickCircleIcon color="success" marginRight={5} />
                      ) : (
                        <WarningSignIcon color="warning" marginRight={5} />
                      )}
                      <Strong color={paid === slot["gross"] ? "success" : "warning"}>
                        {`${getCurrency()} ${paid} / ${slot["gross"]}`}
                      </Strong>
                    </Pane>
                    {!slot["isPlayoBooking"] && (
                      <Button
                        appearance={"minimal"}
                        paddingLeft={0}
                        paddingRight={0}
                        onClick={() =>
                          showEditAmountDialog(true, {
                            bookingId: slot["bookingId"],
                            slot: slot["startTime"],
                          })
                        }
                      >
                        Edit Gross Amount
                      </Button>
                    )}
                  </Pane>
                  <Button
                    className={"unavailable-button"}
                    appearance={"default"}
                    intent={"danger"}
                    onClick={() => {
                      showDialog(false);
                      showConfirmationDialog({
                        status: true,
                        header: "Booking Cancellation",
                        confirmLabel: "Yes",
                        cancelLabel: "No",
                        intent: "danger",
                        information: (
                          <Pane display={"flex"} flexDirection={"column"}>
                            <Pane
                              display={"flex"}
                              flexDirection={"row"}
                              flexBasis={"100%"}
                              justifyContent={"space-between"}
                              marginBottom={10}
                            >
                              <Strong>{date}</Strong>
                              <Strong>
                                {`${getFormattedTime(slot["startTime"])} -
                                                        ${getFormattedTime(slot["endTime"])}`}
                              </Strong>
                            </Pane>
                            <Pane
                              display={"flex"}
                              flexDirection={"row"}
                              flexBasis={"100%"}
                              justifyContent={"space-between"}
                              marginBottom={10}
                            >
                              <Strong>{slot["bookingId"]}</Strong>
                              <Text>{slot["courtName"]}</Text>
                            </Pane>
                            <Pane
                              display={"flex"}
                              flexDirection={"row"}
                              flexBasis={"100%"}
                              justifyContent={"space-between"}
                            >
                              <Text>{slot["customerName"]}</Text>
                              <Text>{slot["customerMobile"]}</Text>
                            </Pane>
                            <Pane
                              width={"100%"}
                              marginTop={"20px"}
                              borderRadius={"5px"}
                              display='flex'
                              alignItems='center'
                              justifyContent='center'
                              background={slot["isPlayoBooking"] ? "#CCFFE7" : "#FFDAD4"}
                              height={"20px"}
                            >
                              <Pane
                               
                                color={slot["isPlayoBooking"] ? "#00331B" : "#410001"}
                              >
                                {slot["isPlayoBooking"] ? "Playo Booking" : "Club Booking"}
                              </Pane>
                            </Pane>
                          </Pane>
                        ),
                        action: () => cancelBooking(slot["bookingId"]),
                      });
                    }}
                  >
                    Cancel
                  </Button>
                </Pane>
                {/* {paid !== slot["gross"] && slot['showPaymentLink'] && <Pane
                                display={"flex"}
                                flexDirection={"row"}
                                justifyContent={"space-between"}
                                width={"100%"}
                            >
                                <Button
                                    display={"flex"}
                                    justifyContent={"center"}
                                    width={"100%"}
                                    intent={"warning"}
                                    appearance={"primary"}
                                    onClick={() => sendBookingPaymentLink(slot['bookingId'])}
                                >
                                    Remind Payment
                                </Button>
                            </Pane>} */}
                <Pane
                  display={"flex"}
                  appearance={"#5C85FF"}
                  textDecoration={"underline"}
                  decoration='underline'
                  justifyContent={"flex-end"}
                  cursor='pointer'
                >
                  <NavLink
                    to={{
                      pathname: "/search",
                      search: `?bookingId=${slot["bookingId"]}`,
                    }}
                  >
                    More Details
                  </NavLink>
                </Pane>
                {slot["isPlayoBooking"] && (
                  <EnableReschedule
                    onReschedule={enableReschedule}
                    rescheduleEnableText={slot["rescheduleEnableText"]}
                    bookingId={slot["bookingId"]}
                    startTime={slot["startTime"]}
                  />
                )}
                {slot["isBnpl"] && !slot["bookingCancelled"] && (
                  <MarkNoSHow onNoShow={onNoShow} bookingId={slot["bookingId"]} />
                )}
              </Card>
            );
          } else {
            return (
              <Card
                key={index}
                marginTop={10}
                padding={20}
                elevation={slot["status"] === "Locked" ? 1 : 0}
                display={"flex"}
                justifyContent={"space-between"}
                flexDirection={"column"}
                // onClick={slot['status'] === "Locked" ? () => getSlotLockedStatus(slot) : null}
                cursor={"pointer"}
              >
                <Pane
                  display={"flex"}
                  flexDirection={"row"}
                  flexBasis={"100%"}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                >
                  <Strong>{slot["courtName"]}</Strong>
                  <Pane
                    hight={32}
                    display={"flex"}
                    flexDirection={"row"}
                    justifyContent={"space-evenly"}
                    alignItems={"center"}
                  > 
                    <BanCircleIcon 
                      color={slot['status'] === "Blocked" ? "danger" : "muted"}
                      marginRight={5}
                    />
                    <Strong color={slot["status"] === "Blocked" ? "danger" : "muted"}>
                      {slot["status"]}
                    </Strong>
                  </Pane>
                </Pane>
              </Card>
            );
          }
        })
      ) : (
        <React.Fragment />
      )}
    </Dialog>
  );
};

const mapStateToProps = ({ slotUnavailabilityData }) => ({
  slotUnavailabilityData,
});

export default connect(mapStateToProps)(UnavailabilityDialog);
